import { PlanningInformationType, PlanningInformationSubtype } from '../../../shared/services/planning.service';
import { Validators, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { FacilityTypeService } from '../../../shared/services/facility-type.service';
import { FacilityNameService } from '../../../shared/services/facility-name.service';
import { Observable } from 'rxjs';
import { asEnumerable } from 'linq-es2015';
var RequestPlanningTreatmentComponent = /** @class */ (function () {
    function RequestPlanningTreatmentComponent(formBuilder, facilityNameService, facilityTypeService) {
        this.formBuilder = formBuilder;
        this.facilityNameService = facilityNameService;
        this.facilityTypeService = facilityTypeService;
        this.facilityTypes = [];
        this.facilityNames = [];
    }
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "flatInstructions", {
        get: function () { return this.treatmentFormGroup.get("flatInstructions"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "flatInstructionsSubstrate", {
        get: function () { return this.flatInstructions.get("substrate"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "flatInstructionsIrrigation", {
        get: function () { return this.flatInstructions.get("irrigation"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "flatInstructionsFertigation", {
        get: function () { return this.flatInstructions.get("fertigation"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "flatLocation", {
        get: function () { return this.flatInstructions.get("flatLocation"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "flatFacilityType", {
        get: function () { return this.flatLocation.get("facilityType"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "flatFacility", {
        get: function () { return this.flatLocation.get("facility"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "pottingInstructions", {
        get: function () { return this.treatmentFormGroup.get("pottingInstructions"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "pottingInstructionsSubstrate", {
        get: function () { return this.pottingInstructions.get("substrate"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "pottingInstructionsIrrigation", {
        get: function () { return this.pottingInstructions.get("irrigation"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "pottingInstructionsFertigation", {
        get: function () { return this.pottingInstructions.get("fertigation"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "automationPotLocation", {
        get: function () { return this.pottingInstructions.get("automationPotLocation"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "automatedFacilityType", {
        get: function () { return this.automationPotLocation.get("facilityType"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "automatedFacility", {
        get: function () { return this.automationPotLocation.get("facility"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "staticPotLocation", {
        get: function () { return this.pottingInstructions.get("staticPotLocation"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "staticFacilityType", {
        get: function () { return this.staticPotLocation.get("facilityType"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "staticFacility", {
        get: function () { return this.staticPotLocation.get("facility"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "plantHandlingInstructions", {
        get: function () { return this.treatmentFormGroup.get("plantHandlingInstructions"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "plantHandlingLighting", {
        get: function () { return this.plantHandlingInstructions.get("lighting"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "plantHandlingTemperature", {
        get: function () { return this.plantHandlingInstructions.get("temperature"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "plantHandlingHumidity", {
        get: function () { return this.plantHandlingInstructions.get("humidity"); },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(RequestPlanningTreatmentComponent.prototype, "sprayBoothStudyInstructions", {
        get: function () { return this.treatmentFormGroup.get("sprayBoothStudyInstructions"); },
        enumerable: true,
        configurable: true
    });
    ;
    RequestPlanningTreatmentComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.buildTreatmentForm();
        Observable.forkJoin(this.facilityTypeService.getAll(), this.facilityNameService.getAll()).subscribe(function (_a) {
            var facilityTypes = _a[0], facilityNames = _a[1];
            _this.facilityTypes = asEnumerable(facilityTypes || [])
                .Where(function (ft) { return ft.isActive; })
                .OrderBy(function (ft) { return ft.order; })
                .ToArray();
            _this.facilityNames = asEnumerable(facilityNames || [])
                .Where(function (fn) { return fn.isActive; })
                .OrderBy(function (fn) { return fn.order; })
                .ThenBy(function (fn) { return fn.name; })
                .ToArray();
        });
    };
    RequestPlanningTreatmentComponent.prototype.showPlantHandlingInstructions = function () {
        return (this.plantHandlingLighting !== null ||
            this.plantHandlingTemperature !== null ||
            this.plantHandlingHumidity !== null);
    };
    RequestPlanningTreatmentComponent.prototype.buildTreatmentForm = function () {
        var _this = this;
        this.treatmentFormGroup.addControl('treatmentNumber', new FormControl(this.existingTreatmentFormData.treatmentNumber));
        this.treatmentFormGroup.addControl('flatInstructions', new FormGroup({}));
        this.treatmentFormGroup.addControl('pottingInstructions', new FormGroup({}));
        this.treatmentFormGroup.addControl('plantHandlingInstructions', new FormGroup({}));
        this.treatmentFormGroup.addControl('sprayBoothStudyInstructions', new FormGroup({}));
        if (!this.existingTreatmentFormData.directSeedToPots) {
            this.flatInstructions.addControl('flatLocation', this.formBuilder.group({
                facilityType: this.formBuilder.control(this.existingTreatmentFormData.flatStorageFacilityTypeId, [Validators.required]),
                facility: this.existingTreatmentFormData.flatStorageFacilityTypeId === -1 ?
                    this.formBuilder.control(this.existingTreatmentFormData.flatStorageFacilityLocationId) :
                    this.formBuilder.control(this.existingTreatmentFormData.flatStorageFacilityLocationId, [Validators.required])
            }));
            this.flatFacilityType.valueChanges.subscribe(function (value) {
                if (value === -1) {
                    _this.flatFacility.clearValidators();
                }
                else {
                    _this.flatFacility.setValidators(Validators.required);
                }
                _this.flatFacility.updateValueAndValidity();
            });
        }
        this.pottingInstructions.addControl('automationPotLocation', this.formBuilder.group({
            facilityType: this.formBuilder.control(this.existingTreatmentFormData.automationPotStorageFacilityTypeId, [Validators.required]),
            facility: this.existingTreatmentFormData.automationPotStorageFacilityTypeId === -1 ?
                this.formBuilder.control(this.existingTreatmentFormData.automationPotStorageLocationId) :
                this.formBuilder.control(this.existingTreatmentFormData.automationPotStorageLocationId, [Validators.required])
        }));
        this.pottingInstructions.addControl('staticPotLocation', this.formBuilder.group({
            facilityType: this.formBuilder.control(this.existingTreatmentFormData.staticPotStorageFacilityTypeId, [Validators.required]),
            facility: this.existingTreatmentFormData.staticPotStorageFacilityTypeId === -1 ?
                this.formBuilder.control(this.existingTreatmentFormData.staticPotStorageLocationId) :
                this.formBuilder.control(this.existingTreatmentFormData.staticPotStorageLocationId, [Validators.required])
        }));
        this.automatedFacilityType.valueChanges.subscribe(function (value) {
            if (value === -1) {
                _this.automatedFacility.clearValidators();
            }
            else {
                _this.automatedFacility.setValidators(Validators.required);
            }
            _this.automatedFacility.updateValueAndValidity();
        });
        this.staticFacilityType.valueChanges.subscribe(function (value) {
            if (value === -1) {
                _this.staticFacility.clearValidators();
            }
            else {
                _this.staticFacility.setValidators(Validators.required);
            }
            _this.staticFacility.updateValueAndValidity();
        });
        var fiSubstrate = this.getComment(PlanningInformationType.FlatInstruction, PlanningInformationSubtype.Substrate, this.existingTreatmentFormData.comments);
        var fiIrrigation = this.getComment(PlanningInformationType.FlatInstruction, PlanningInformationSubtype.Irrigation, this.existingTreatmentFormData.comments);
        var fiFertigation = this.getComment(PlanningInformationType.FlatInstruction, PlanningInformationSubtype.Fertigation, this.existingTreatmentFormData.comments);
        var piSubstrate = this.getComment(PlanningInformationType.PottingInstruction, PlanningInformationSubtype.Substrate, this.existingTreatmentFormData.comments);
        var piIrrigation = this.getComment(PlanningInformationType.PottingInstruction, PlanningInformationSubtype.Irrigation, this.existingTreatmentFormData.comments);
        var pifertigation = this.getComment(PlanningInformationType.PottingInstruction, PlanningInformationSubtype.Fertigation, this.existingTreatmentFormData.comments);
        var phLighting = this.getComment(PlanningInformationType.PlantHandlingInstruction, PlanningInformationSubtype.Lighting, this.existingTreatmentFormData.comments);
        var phTemperature = this.getComment(PlanningInformationType.PlantHandlingInstruction, PlanningInformationSubtype.Temperature, this.existingTreatmentFormData.comments);
        var phHumidity = this.getComment(PlanningInformationType.PlantHandlingInstruction, PlanningInformationSubtype.Humidity, this.existingTreatmentFormData.comments);
        if (fiSubstrate)
            this.flatInstructions.addControl('substrate', fiSubstrate);
        if (fiIrrigation)
            this.flatInstructions.addControl('irrigation', fiIrrigation);
        if (fiFertigation)
            this.flatInstructions.addControl('fertigation', fiFertigation);
        if (piSubstrate)
            this.pottingInstructions.addControl('substrate', piSubstrate);
        if (piIrrigation)
            this.pottingInstructions.addControl('irrigation', piIrrigation);
        if (pifertigation)
            this.pottingInstructions.addControl('fertigation', pifertigation);
        if (phLighting)
            this.plantHandlingInstructions.addControl('lighting', phLighting);
        if (phTemperature)
            this.plantHandlingInstructions.addControl('temperature', phTemperature);
        if (phHumidity)
            this.plantHandlingInstructions.addControl('humidity', phHumidity);
    };
    RequestPlanningTreatmentComponent.prototype.getComment = function (type, subtype, comments) {
        if (comments.some(function (t) { return t.instructionType === type && t.instructionSubtype === subtype; })) {
            var comment = comments.find(function (t) { return t.instructionType === type && t.instructionSubtype === subtype; }).comment;
            return this.formBuilder.control(comment, [Validators.required]);
        }
        return null;
    };
    RequestPlanningTreatmentComponent.prototype.copyValueFrom = function (copyArgs) {
        if (!this.existingTreatmentFormData.directSeedToPots && !copyArgs.directSeedToPots) {
            this.setDynamicFormValue(this.flatInstructionsSubstrate, copyArgs.flatInstructions.substrate);
            this.setDynamicFormValue(this.flatInstructionsFertigation, copyArgs.flatInstructions.fertigation);
            this.setDynamicFormValue(this.flatInstructionsIrrigation, copyArgs.flatInstructions.irrigation);
            this.setDynamicFormValue(this.flatFacilityType, copyArgs.flatInstructions.flatLocation.facilityType);
            this.setDynamicFormValue(this.flatFacility, copyArgs.flatInstructions.flatLocation.facility);
        }
        this.setDynamicFormValue(this.pottingInstructionsSubstrate, copyArgs.pottingInstructions.substrate);
        this.setDynamicFormValue(this.pottingInstructionsFertigation, copyArgs.pottingInstructions.fertigation);
        this.setDynamicFormValue(this.pottingInstructionsIrrigation, copyArgs.pottingInstructions.irrigation);
        this.setDynamicFormValue(this.automatedFacilityType, copyArgs.pottingInstructions.automationPotLocation.facilityType);
        this.setDynamicFormValue(this.automatedFacility, copyArgs.pottingInstructions.automationPotLocation.facility);
        this.setDynamicFormValue(this.staticFacilityType, copyArgs.pottingInstructions.staticPotLocation.facilityType);
        this.setDynamicFormValue(this.staticFacility, copyArgs.pottingInstructions.staticPotLocation.facility);
        this.setDynamicFormValue(this.plantHandlingHumidity, copyArgs.plantHandlingInstructions.humidity);
        this.setDynamicFormValue(this.plantHandlingTemperature, copyArgs.plantHandlingInstructions.temperature);
        this.setDynamicFormValue(this.plantHandlingLighting, copyArgs.plantHandlingInstructions.lighting);
        this.treatmentFormGroup.updateValueAndValidity();
    };
    RequestPlanningTreatmentComponent.prototype.setDynamicFormValue = function (formControl, value) {
        if (formControl && value) {
            formControl.setValue(value);
        }
    };
    RequestPlanningTreatmentComponent.prototype.copySprayEventsFrom = function (copyArgs) {
        var sprayBoothGroup = this.treatmentFormGroup.get("sprayBoothStudyInstructions");
        if (!sprayBoothGroup)
            return;
        var sprayEventArrayControl = sprayBoothGroup.get("sprayEventDaysAfterPlantingList");
        if (!sprayEventArrayControl || !sprayEventArrayControl.controls)
            return;
        var srcList = copyArgs &&
            copyArgs.sprayEventDaysAfterPlanting &&
            Array.isArray(copyArgs.sprayEventDaysAfterPlanting.sprayEventDaysAfterPlantingList)
            ? copyArgs.sprayEventDaysAfterPlanting.sprayEventDaysAfterPlantingList
            : [];
        var controls = sprayEventArrayControl.controls;
        for (var i = 0; i < controls.length; i++) {
            if (controls[i] && srcList.length > i) {
                controls[i].setValue(srcList[i]);
            }
        }
        this.treatmentFormGroup.updateValueAndValidity();
    };
    return RequestPlanningTreatmentComponent;
}());
export { RequestPlanningTreatmentComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-planning-modal/request-planning-treatment/request-planning-treatment.component.ts.pre-build-optimizer.js